import React from 'react'
import styles from './About.module.css';

export default function About() {
  return <>
    <div>About</div>
  </>
}
